import { Component } from "react";
import { mapFileDataToSystem } from "../../utility/DataMapHelper";
import { validateRecord } from "../../utility/RecordValidator";
import AddSegmentPopup from "../../../common/AddSegmentPopup";
import {
  DKLabel,
  DKButton,
  DKListPicker,
  DKDataGrid,
  DKIcon,
  DKIcons,
  DKCheckMark,
  showAlert,
  showToast,
  TOAST_TYPE,
} from "deskera-ui-library";
import RouteManager from "../../../../managers/RouteManager";
import Utility, { deepClone } from "../../../../utility/Utility";
import i18next from "i18next";

class Confirm extends Component {
  constructor(props) {
    super(props);

    this.maxRecordsToDisplay = 25;

    this.state = {
      importRecords: this.props.importRecords || [],
      invalidRows: this.props.invalidRows,
      showInvalidOnly: false,
      openSegmentPicker: false,
      segmentPickerBorder: this.props.selectedSegmentId.length
        ? "border-blue"
        : "border-m",
      segmentValues: deepClone(this.props.segmentValues),
      selectedSegments: this.props.selectedSegmentId,
      jobStageId: this.props.jobStageId,
      needAddSegmentPopup: false,
      expandPropsPanel: true,
      currentPage: 1,
    };
  }

  componentWillReceiveProps(nextProp) {
    this.setState({
      importRecords: nextProp.importRecords || [],
      selectedSegments: nextProp.selectedSegmentId,
      jobStageId: nextProp.jobStageId,
      segmentPickerBorder: nextProp.selectedSegmentId.length
        ? "border-blue"
        : "border-m",
      invalidRows: nextProp.invalidRows,
    });
  }

  componentDidMount() {
    const { mappedHeaders, fileContent, tableColumns } = this.props;
    if (!this.state.importRecords.length && mappedHeaders && fileContent) {
      mapFileDataToSystem(mappedHeaders, fileContent[0], tableColumns)
        .then((data) => {
          const { importRecords, invalidRows } = data;
          this.props.setData({ importRecords, invalidRows });
        })
        .catch((err) => {
          showToast(err, TOAST_TYPE.FAILURE);
        });
    }
    window.addEventListener("onSideBarChange", this.windowSizeUpdated);
  }

  componentWillUnmount() {
    window.removeEventListener("onSideBarChange", this.windowSizeUpdated);
  }

  handlePropertiesUpdates = (event, propIndex, selectedOption) => {
    const updatedProperties = [...this.props.importProperties];
    const updatedProperty = { ...updatedProperties[propIndex] };
    updatedProperty.options = updatedProperty.options.map(
      (option, optionIndex) => {
        if (selectedOption === optionIndex) {
          option.checked = true;
          updatedProperty.selectedOption = option.value;
        } else {
          option.checked = false;
        }
        return option;
      }
    );

    updatedProperties[propIndex] = updatedProperty;

    this.props.setData({
      importProperties: updatedProperties,
    });
  };

  togglePropertiesPanel = () => {
    this.setState((prevState) => ({
      expandPropsPanel: !prevState.expandPropsPanel,
    }));
  };

  getImportPropertiesPanel() {
    const { expandPropsPanel } = this.state;
    return (
      <div className="column bg-white mt-xl parent-width shadow-s border-radius-s position-relative">
        <div
          className={`column parent-width p-r cursor-hand ${
            expandPropsPanel && "border-m-b"
          }`}
          onClick={this.togglePropertiesPanel}
        >
          <DKLabel
            text="Import Properties"
            className="fs-l fw-m parent-width justify-content-between"
          />
          <DKLabel
            text="Customize how you would like to import the new records in the system"
            className="text-gray fs-m mt-s"
          />
          <DKIcon
            src={
              expandPropsPanel ? DKIcons.ic_arrow_up2 : DKIcons.ic_arrow_down2
            }
            className="position-absolute"
            style={{ right: 40, top: 25, height: 20 }}
          />
        </div>
        {expandPropsPanel &&
          this.props.importProperties.map((importProperty, propertyIndex) => (
            <div className="column bg-white p-h-xl parent-width">
              <DKLabel
                text={importProperty.title}
                className="fs-m fw-m pt-r pb-s"
              />
              <div className="row justify-content-start border-m-b pb-m">
                {importProperty.options.map((option, optionIndex) => (
                  <label
                    htmlFor={`import-${propertyIndex}-option-${optionIndex}`}
                    className="p-s row align-items-center width-auto cursor-hand"
                  >
                    <input
                      type="radio"
                      className="mb-xs"
                      id={`import-${propertyIndex}-option-${optionIndex}`}
                      checked={option.checked}
                      onChange={(e) =>
                        this.handlePropertiesUpdates(
                          e,
                          propertyIndex,
                          optionIndex
                        )
                      }
                    />
                    <DKLabel
                      className="fs-m pl-xs pr-l"
                      text={option.displayValue}
                    />
                  </label>
                ))}
              </div>
            </div>
          ))}
      </div>
    );
  }

  toggleAddSegmentPopup = () => {
    this.setState((prev) => ({
      needAddSegmentPopup: !prev.needAddSegmentPopup,
      openSegmentPicker: true,
    }));
  };

  onAddNewSegment = (data, segment) => {
    this.toggleAddSegmentPopup();
    const newSelectedSegments = this.state.selectedSegments.concat(segment.id);
    let newSegmentValue = deepClone(this.state.segmentValues)
    if(newSegmentValue) {
      const isExist = newSegmentValue.options?.find(o=>o.id === segment.id);
      if(!isExist) {
        newSegmentValue.options?.push(segment);
      }
    }
      this.setState(
      {
        segmentValues: newSegmentValue,
        openSegmentPicker:false
      },
      () => {
        this.props.setData({ selectedSegmentId: newSelectedSegments });
      }
    );
  };

  getAddSegmentPopup() {
    return (
      <AddSegmentPopup
        onCancel={this.hideAddSegmentPopup}
        onSave={this.onAddNewSegment}
      />
    );
  }

  onClearSelectedSegment = (segmentIdToRemove) => {
    const pipelineToRemove = this.props.jobPipelines.find(jp=>jp.id===segmentIdToRemove);
    let newJobStageIds = [...this.state.jobStageId]
    if(pipelineToRemove) {
      pipelineToRemove.stage_id_s.forEach(stage=>{
         const stageIndex = this.state.jobStageId.findIndex(j=>j===stage)
        if(stageIndex !== -1) {
          this.state.jobStageId?.splice(stageIndex,1);
          newJobStageIds = this.state.jobStageId;
        }
      })
    }
    const newSegments = this.state.selectedSegments.filter(
      (segmentId) => segmentId !== segmentIdToRemove
    );
    
    this.props.setData({ selectedSegmentId: newSegments, jobStageId:newJobStageIds });
  };

  onToggleSegmentPicker = () => {
    this.setState((prev) => ({ openSegmentPicker: !prev.openSegmentPicker }));
  };

  onSelectSegment = (segmentIndex) => {
    const newSegments = [...this.state.selectedSegments];
    const jobStages = [...this.state.jobStageId];
    const newSegmentId = this.state.segmentValues.options[segmentIndex].id;
    const newStage = (
        Array.isArray(this.state.segmentValues.options[segmentIndex].stage_id_s) && 
        this.state.segmentValues.options[segmentIndex].stage_id_s[0]
      ) ? this.state.segmentValues.options[segmentIndex].stage_id_s[0] : []
    /* Close the segment picker */
    this.onToggleSegmentPicker();
    
    if (newSegments.indexOf(newSegmentId) === -1) {
      newSegments.push(newSegmentId);
      if(jobStages.indexOf(newStage) === -1 && !Utility.isEmpty(newStage)) {
        jobStages.push(newStage)
      }
      this.props.setData({
        selectedSegmentId: newSegments,
        jobStageId: jobStages
      });
    }
  };

  getProceedConfirmation = () => {
    const { invalidRows, importRecords } = this.state;
    /* If no invalid rows present then proceed without alert */
    if (!invalidRows?.length) {
      this.props.confirmationHandler(null);
      return;
    }

    const buttons = [
      {
        title: "Cancel",
        className: "bg-gray1 border-m",
      },
      {
        title: "Proceed",
        className: "bg-app text-white ml-r",
        onClick: (e) => this.props.confirmationHandler(e),
      },
    ];
    showAlert(
      "Import Records",
      `${invalidRows.length} out of ${importRecords.length} records contains invalid fields, do you want to proceed?`,
      buttons
    );
  };

  onProceedToNextStep = (e) => {
    if (this.state.selectedSegments?.length) {
      const isValidJobOpeningSelect = this.state.selectedSegments.find(seg=> typeof seg === 'number')
      if(isValidJobOpeningSelect) {
        this.getProceedConfirmation();
      } else {
        showAlert('Alert',i18next.t('JOB_OPENING_ALERT'),[
          {
              title: "Continue",
              className: "bg-app text-white mr-r",
              onClick: () => this.getProceedConfirmation()
          },
          {
              title: "Cancel",
              className: "bg-gray1 border-m",
          }
      ]);
      }
      
    } else {
      showToast(
        "Please choose Job Opening(s) for import records first.",
        TOAST_TYPE.FAILURE
      );
      this.setState({ segmentPickerBorder: "border-red" });
      return;
    }
  };

  getSegmentSection() {
    if (!this.state.segmentValues?.options) return null;

    const segmentListOptions = this.state.segmentValues.options.map(
      (option) => option.name
    );
    return (
      <div className="column bg-white mt-xl parent-width shadow-s border-radius-s position-relative">
        <div className="p-r column parent-width border-m-b">
          <DKLabel text="Job Openings*" className="fs-l fw-m" />
          <DKLabel
            text="Categorize imported records in existing or new Job Openings"
            className="text-gray fs-m mt-s"
          />
        </div>
        {this.state.openSegmentPicker && (
          <DKListPicker
            title="Job Openings"
            className="position-absolute border-m shadow-m z-index-3"
            style={{ top: "50%", left: 10, width: 250 }}
            data={segmentListOptions}
            required={true}
            onSelect={this.onSelectSegment}
            onClose={this.onToggleSegmentPicker}
            button={{
              title: "Create Job Openings",
              className: "bg-app text-white",
              onClick: this.toggleAddSegmentPopup,
            }}
          />
        )}
        <div className="row p-r border-m-b">
          <DKButton
            title={"Job Openings"}
            className={`m-l ${this.state.segmentPickerBorder} justify-content-between`}
            style={{ width: 200, marginLeft: 0 }}
            icon={DKIcons.ic_arrow_down}
            isReverse={true}
            onClick={this.onToggleSegmentPicker}
          />
          {this.state.selectedSegments.map((segmentId) => {
            const result = this.state.segmentValues.options.filter(
              (option) => option.id === segmentId
            )[0];
            return (
              <div
                className={`row width-auto border-m border-radius-m p-h-r p-v-xs m-h-r ${result?.color}`}
              >
                <DKLabel text={result?.name} />
                <DKIcon
                  src={DKIcons.ic_close_}
                  className="pl-s ic-xs cursor-hand"
                  onClick={(e) => {
                    e.stopPropagation();
                    this.onClearSelectedSegment(segmentId);
                  }}
                />
              </div>
            );
          })}
        </div>
        <div className="row m-v-l">
          <DKButton
              title="Cancel"
              className="border-m ml-r bg-white"
              onClick={() => {
                RouteManager.navigateToPage(this.props.source || "/");
              }}
          />
          <DKButton
            title="Back"
            className="border-m ml-m bg-white"
            onClick={this.props.backStepHandler}
          />
          <DKButton
            title={`Confirm & Proceed`}
            className="border-m ml-r bg-app text-white"
            onClick={this.onProceedToNextStep}
          />
        </div>
        {this.state.needAddSegmentPopup && this.getAddSegmentPopup()}
      </div>
    );
  }

  onRowUpdate = (editedData) => {
    /* Handle Validations */
    const { invalidRows } = this.state;

    const invalidFields = validateRecord(
      editedData.rowData,
      this.props.tableColumns
    );
    editedData.rowData.invalidFields = invalidFields;

    let actualRecordIndex = editedData.rowData.recordIndex;
    let updatedInvalidRows = [...invalidRows];

    if (invalidFields.length && !invalidRows.includes(actualRecordIndex)) {
      updatedInvalidRows.push(actualRecordIndex);
    } else if (!invalidFields.length && invalidRows.includes(actualRecordIndex)) {
      const index = updatedInvalidRows.findIndex((invalidRow) => editedData.rowIndex === invalidRow);
      updatedInvalidRows.splice(index, 1);
    } else {
      /* no update required */
      return;
    }

    this.props.setData({ invalidRows: updatedInvalidRows });
  };

  getRecordsToDisplay(recordStartIndex) {
    const { importRecords, invalidRows, showInvalidOnly } = this.state;

    let displayRecords = [],
      totalRecordCount = 0;

    if (showInvalidOnly) {
      const currPageInvalidRows = invalidRows.slice(
        recordStartIndex,
        recordStartIndex + this.maxRecordsToDisplay
      );
      displayRecords = currPageInvalidRows.map((rowId) => importRecords[rowId]);
      totalRecordCount = invalidRows.length;
    } else {
      displayRecords = importRecords.slice(
        recordStartIndex,
        recordStartIndex + this.maxRecordsToDisplay
      );
      totalRecordCount = importRecords.length;
    }

    displayRecords.forEach((record) => {
        record["invalidFields"] = validateRecord(record, this.props.tableColumns);
    });

    return { displayRecords, totalRecordCount };
  }

  getPaginationData() {
    const { currentPage, showInvalidOnly } = this.state;

    const recordStartIndex = (currentPage - 1) * this.maxRecordsToDisplay;
    const { displayRecords, totalRecordCount } = this.getRecordsToDisplay(
      recordStartIndex
    );

    const currStartRowIndex = recordStartIndex + 1;
    const currEndRowIndex = recordStartIndex + displayRecords.length;
    const paginationHeader = totalRecordCount
      ? `Showing ${currStartRowIndex}-${currEndRowIndex} of ${totalRecordCount} ${
          showInvalidOnly ? "invalid" : "imported"
        } records`
      : `No ${showInvalidOnly ? "invalid" : "imported"} records present`;

    const totalPageCount = Math.ceil(
      totalRecordCount / this.maxRecordsToDisplay
    );

    return {
      currentPage,
      displayRecords,
      totalPageCount,
      paginationHeader,
    };
  }

  toggleInvalidRecords = () => {
    this.setState((prev) => ({
      showInvalidOnly: !prev.showInvalidOnly,
      currentPage: 1,
    }));
  };

  getRecordsPanel() {
    const {
      currentPage,
      displayRecords,
      totalPageCount,
      paginationHeader,
    } = this.getPaginationData();

    return (
      <div className="position-relative bg-white shadow-s mt-xl p-v-s border-radius-s">
        <div
          className="position-absolute z-index-3 cursor-hand"
          style={{ right: 20, top: 40 }}
          onClick={this.toggleInvalidRecords}
        >
          <DKCheckMark
            className="fw-m"
            title="Show Invalid Records Only"
            isSelected={this.state.showInvalidOnly}
          />
        </div>
        <DKDataGrid
          width="79vw"
          title={`<h2 class="pl-xs fs-l m-v-s"> Import Records</h2><p class="text-gray pl-s fs-m fw-r m-v-s">${paginationHeader}</p>`}
          columns={[...this.props.tableColumns]}
          rows={displayRecords}
          allowRowEdit={true}
          onRowUpdate={this.onRowUpdate}
          currentPage={currentPage}
          totalPageCount={totalPageCount}
          onPrevPageTapped={() =>
            this.setState({ currentPage: currentPage - 1 })
          }
          onNextPageTapped={() =>
            this.setState({ currentPage: currentPage + 1 })
          }
        />
      </div>
    );
  }

  render() {
    return (
      <div className="column" style={{ width: "79vw" }}>
        {this.getImportPropertiesPanel()}
        {this.getSegmentSection()}
        {this.getRecordsPanel()}
      </div>
    );
  }
}

export default Confirm;
